import SpecialValue from '@/commons/wildcards/constants/SpecialValue';

class OperationUtil {
  /**
   * Kiểm tra compare theo toán tử
   * @author nnnam - 17/8/2022
   * @param {*} val
   * @param {*} compare
   * @param {*} opera
   */
  compareByOpera(val, compare, opera) {
    let that = this;
    switch (opera) {
      case '=':
        return val == compare;
        break;
      case '>':
        return val > compare;
        break;
      case '>=':
        return val >= compare;
        break;
      case '<':
        return val < compare;
        break;
      case '<=':
        return val <= compare;
        break;
      case '!=':
        return val != compare;
        break;
      case '*':
        return val?.toString().contains(compare);
        break;
      case '.*':
        return val?.toString().endsWith(compare);
        break;
      case '*.':
        return val?.toString().startsWith(compare);
        break;
      case '!*':
        return !val?.toString().contains(compare);
        break;
      case 'NULL':
        val == null;
        break;
      case 'NOT NULL':
        val != null;
        break;
      case '':
        break;
    }

    return true;
  }

  /**
   * Xử lý thêm các giá trị đặc biệt (Tổng hợp, ...)
   * @author nnnam - 17/8/2022
   * @param {*} key
   * @param {*} option
   * @returns
   */
  addSpecialValue(key, option) {
    let that = this;
    let func = function (data, payload) {
      let filter = JSON.parse(payload?.filter || '[]');
      let fields = ['code', 'name'].map(x => [key, x].join('_'));
      let filts = filter.filter(x => fields.includes(x.Field));

      var objSumary = {
        name: SpecialValue.SummaryText,
        display: SpecialValue.Summary,
        number: SpecialValue.Summary,
        code: SpecialValue.Summary,
      };

      var objNone = {
        name: SpecialValue.NoneText,
        display: SpecialValue.None,
        number: SpecialValue.None,
        code: SpecialValue.None,
      };

      var objAll = {
        name: SpecialValue.AllText,
        display: SpecialValue.All,
        code: SpecialValue.All,
        number: SpecialValue.All,
      };

      option.data?.forEach(val => {
        var obj = {
          id: val,
        };

        switch (val) {
          case SpecialValue.AllInt:
          case SpecialValue.AllId:
          case SpecialValue.AllGuid:
          case SpecialValue.All:
            obj = { ...obj, ...objAll };
            break;
          case SpecialValue.SummaryInt:
          case SpecialValue.SummaryId:
          case SpecialValue.SummaryGuid:
          case SpecialValue.Summary:
            obj = { ...obj, ...objSumary };
            break;
          case SpecialValue.NoneInt:
          case SpecialValue.NoneId:
          case SpecialValue.None:
            obj = { ...obj, ...objNone };
            break;
        }

        let mapObj = Object.keys(obj).reduce((o, x) => ({ ...o, [`${key}_${x}`]: obj[x] }), { [key]: val });

        option?.custom && option?.custom(mapObj, val);

        let invalid = false;

        if (filts.length) {
          invalid = filts.some(x => !that.compareByOpera(mapObj[x.Field], x.Value, x.Operator));
        }

        !invalid && data.unshift(mapObj);
      });

      return data;
    };
    return func;
  }

  /**
   * Kiểm tra có phải Tổng hợp không?
   * @param {any} val
   * @returns
   */
  isSummaryValue(val) {
    let arr = [
      SpecialValue.SummaryInt,
      SpecialValue.SummaryId,
      SpecialValue.SummaryGuid,
      SpecialValue.SummaryText,
      SpecialValue.Summary,
    ];

    if (Array.isArray(val)) {
      return arr.some(x => val.includes(x));
    } else {
      return arr.includes(val);
    }
  }

  /**
   * Kiểm tra có phải Tổng hợp không?
   * @param {any} val
   * @returns
   */
  isAllValue(val) {
    let arr = [SpecialValue.AllInt, SpecialValue.AllId, SpecialValue.AllGuid, SpecialValue.AllText, SpecialValue.All];

    if (Array.isArray(val)) {
      return arr.some(x => val.includes(x));
    } else {
      return arr.includes(val);
    }
  }

  /**
   * Lấy giá trị combo
   * @author nnnam - 27/9/2022
   * @param {*} val
   * @returns
   */
  getValueCombo(val) {
    let arr = [
      SpecialValue.SummaryInt,
      SpecialValue.SummaryId,
      SpecialValue.SummaryGuid,
      SpecialValue.Summary,
      SpecialValue.SummaryText,
      SpecialValue.AllInt,
      SpecialValue.AllId,
      SpecialValue.AllGuid,
      SpecialValue.All,
      SpecialValue.AllText,
    ];

    if (Array.isArray(val)) {
      return arr.some(x => val.includes(x)) ? null : JSON.stringify(val);
    } else {
      return arr.includes(val) ? null : val;
    }
  }

  getValueComboJoin(val) {
    let arrSum = [SpecialValue.SummaryInt, SpecialValue.SummaryId, SpecialValue.SummaryGuid, SpecialValue.Summary];

    let arrAll = [SpecialValue.AllInt, SpecialValue.AllId, SpecialValue.AllGuid, SpecialValue.All];
    let arr = [arrSum, arrAll];

    if (Array.isArray(val)) {
      var items = arr.find(x => x.some(o => val.includes(x)));
      if (items) {
        return items.find(x => val.includes(x));
      } else {
        return val?.join(',');
      }
    } else {
      return val;
    }
  }

  /**
   * Thêm các giá trị special vào dữ liệu
   * @author nnnam - 27/9/2022
   * @param {*} vals
   * @returns
   * Modified by NVTUAN1 28.10.2022: Bổ sung thêm case Tất cả, Tổng hợp
   */
  getSpecialEnum(vals) {
    return vals.map(val => {
      switch (val) {
        case SpecialValue.Summary:
          return {
            enumValue: SpecialValue.SummaryInt,
            enumKey: SpecialValue.Summary,
            enumText: SpecialValue.Summary,
          };
        case SpecialValue.SummaryText:
          return {
            enumValue: SpecialValue.SummaryInt,
            enumKey: SpecialValue.SummaryText,
            enumText: SpecialValue.SummaryText,
          };
        case SpecialValue.All:
          return {
            enumValue: SpecialValue.AllInt,
            enumKey: SpecialValue.All,
            enumText: SpecialValue.All,
          };
        case SpecialValue.AllText:
          return {
            enumValue: SpecialValue.AllInt,
            enumKey: SpecialValue.AllText,
            enumText: SpecialValue.AllText,
          };
        case SpecialValue.None:
          return {
            enumValue: SpecialValue.NoneInt,
            enumKey: SpecialValue.None,
            enumText: SpecialValue.None,
          };
      }
    });
  }
}

export default new OperationUtil();
